import React from "react"
import styled from "styled-components"
import Who from "./WhoAreYou-item"

const ViewTabs = ({ options, images }) => {
  const [value, setValue] = React.useState(0)
  return (
    <Wrapper>
      <div className="section-center">
        <h2>Who are you?</h2>
        <div className="buttons">
          {options.map((item, index) => {            
            return (
              <button
                key={index}
                className={`btn btn-who ${index === value && "active"}`}
                onClick={() => setValue(index)}
              >
                {item.title}
              </button>
            )
          })}
        </div>
        <article className="article">
          <Who
            image={images[value].childImageSharp.fluid}
            header={options[value].header}
            text={options[value].text}
            index={value}
          />
        </article>
      </div>
    </Wrapper>
  )
}

const Wrapper = styled.article`
  
  display: none;
  
  @media screen and (min-width: 1025px) {
    display: inherit;
    margin: 174px auto 0;
    border-radius: 10px;
    width: 93vw;
    max-width: 1360px;
  padding: 100px 50px;
  background: var(--clr-primary-6);
  }

  .buttons {
    margin-top: 3.4375rem;
    display: flex;
    justify-content: space-between;
  }

  .btn-who {
    text-align: center;
    background: var(--clr-primary-6);
    color: var(--clr-white);
    border: 2px solid var(--clr-white);
    padding: 1.2rem 0.2px;
    width: 240px;
    font-size: 14px;
    font-family: var(--ff-primary);
    :hover {
      background: var(--clr-white);
      color: var(--clr-primary-1);
    }
    /* Remove de blue border in chrome */
    :focus {
      outline: 0;
    }
  }
  .active {
    background: var(--clr-white);
    color: var(--clr-primary-1);
    border: 2px solid var(--clr-white);
  }

`

export default ViewTabs
